import React from "react";
var __jsx = React.createElement;
import stl from "./BanksGroup.module.css";
import { useCMS } from "@hooks/useCMS";
import { useLang } from "@/common/Contexts/LanguageContext";
import { financeUrlHelper } from "@/pages/financing/helpers/financingHelpers";
var BanksGroup = function BanksGroup(props) {
  var title = props.title,
    banks = props.banks;
  var _props$cta = props.cta,
    text = _props$cta.text,
    url = _props$cta.url;
  var lang = useLang();
  var finalUrl = url && financeUrlHelper(url, lang);
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.partnersContainer
  }, /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("div", {
    className: stl.banksCont
  }, banks.map(function (bank, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx
    }, /*#__PURE__*/React.createElement("img", {
      loading: "lazy",
      src: imageUrl(bank.logo),
      alt: bank.logo.caption || bank.name,
      width: "126px",
      height: "120px"
    }), /*#__PURE__*/React.createElement("h3", null, bank.name));
  })), text && finalUrl && /*#__PURE__*/React.createElement("a", {
    href: finalUrl,
    className: ["blueBtn", stl.partnersButton].join(" ")
  }, text));
};
export default BanksGroup;